import React, { useEffect } from 'react'
import { NoiseAnalysis } from '../../../NoiseAnalysis'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

export const NoiseTab: React.FC = () => {
  const { entity } = useAnalysisMode()
  const { getSectionData } = useAnalysisServices()
  const { setActiveSection } = useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('noise')
  }, [setActiveSection])

  const noiseData = getSectionData('noise') || entity?.noise || {}

  return <NoiseAnalysis data={noiseData} />
}
